import Work1 from "../../assets/ninjamail.PNG";
import Work2 from "../../assets/SMS.PNG";
import Work3 from "../../assets/SEO.PNG";
import Work4 from "../../assets/nordic.PNG";
import Work5 from "../../assets/eschool.PNG";
import Work6 from "../../assets/besnik.PNG";
import Work7 from "../../assets/calculator.PNG";
import Work8 from "../../assets/crud.PNG";
import Work9 from "../../assets/microsoft.PNG";
import Work10 from "../../assets/facebook.PNG";
import Work11 from "../../assets/numtoword.PNG";
import Work12 from "../../assets/MovieApp.PNG";
import Work13 from "../../assets/Zentry.PNG";
import Work14 from "../../assets/thinkboard.PNG";

const Menu = [
  {
    id: 1,
    image: Work1,
    title: "NinjaMail QuestAI",
    category: "Static",
    link: "https://ninjamail-hassam.netlify.app/",
  },
  {
    id: 2,
    image: Work2,
    title: "Student Management System",
    category: "Dynamic",
    link: "https://hackathon-project-hassam.netlify.app/",
  },
  {
    id: 3,
    image: Work3,
    title: "SEO Company",
    category: "Static",
    link: "https://seo-company-hassam.netlify.app/",
  },
  {
    id: 4,
    image: Work4,
    title: "Nordic Rose",
    category: "Static",
    link: "https://nordic-rose-parzival.netlify.app/",
  },
  {
    id: 5,
    image: Work5,
    title: "E-School Website",
    category: "Static",
    link: "https://e-school-hassam.netlify.app/",
  },
  {
    id: 6,
    image: Work6,
    title: "Besnik Realtor",
    category: "Static",
    link: "https://realtor-app-hassam.netlify.app/",
  },
  {
    id: 7,
    image: Work7,
    title: "Scientific Calculator",
    category: "Dynamic",
    link: "https://github.com/Hassamaziz/React-Calculator-Scientific",
  },
  {
    id: 8,
    image: Work8,
    title: "Crud App with Authentication",
    category: "Dynamic",
    link: "https://github.com/Hassamaziz/FIREBASE-CRUD-SIGNUP",
  },
  {
    id: 9,
    image: Work9,
    title: "Microsoft Clone",
    category: "Tailwind",
    link: "https://github.com/Hassamaziz/Microsoft-Clone-Using-Tailwind",
  },
  {
    id: 10,
    image: Work10,
    title: "Facebook Login Clone",
    category: "Tailwind",
    link:
      "https://github.com/Hassamaziz/Practicing-with-tailwind-CSS/tree/main/Facebook%20Login%20Using%20tailwind",
  },
  {
    id: 11,
    image: Work11,
    title: "Number To Words Conversion",
    category: "Dynamic",
    link:
      "https://github.com/Hassamaziz/SMIT-Batch-6-E-A/tree/main/Numbers%20to%20Words%20conversion",
  },
  {
    id: 12,
    image: Work12,
    title: "Movie App",
    category: "Dynamic",
    link: "https://movie-app-lac-phi.vercel.app/",
  },
  {
    id: 13,
    image: Work13,
    title: "Zentry",
    category: "Dynamic",
    link: "https://award-winning-lac.vercel.app/",
  }, 
  {
    id: 14,
    image: Work14,
    title: "ThinkBoard",
    category: "Dynamic",
    link: "https://notes-app-1mue.onrender.com/",
  },
];

export default Menu.reverse();
